import { nextTick } from 'vue';

export default {
    install(app) {
        app.config.globalProperties.$removeFocus = async function (event) {
            if (typeof event === 'boolean') {
                if (!event) {
                    await nextTick();
                    setTimeout(() => {
                        if (document.activeElement) {
                            document.activeElement.blur();
                        }
                    }, 100);
                }
            }

            if (event instanceof PointerEvent) {
                if ( event?.target instanceof Element && event?.target.className.includes('mdi-close-circle')) {
                    await nextTick();
                    document.activeElement?.blur();
                }
            }
        };
    }
};
